/**
 * Match Update Log Service
 * Logs all updates to matches including reschedule requests, approvals, referee changes, etc.
 */

import { collection, addDoc, query, where, orderBy, getDocs, Timestamp } from 'firebase/firestore';
import { db } from '../firebase/config';

export const LOG_TYPES = {
  CREATED: 'created',
  SCHEDULED: 'scheduled',
  RESCHEDULE_REQUESTED: 'reschedule_requested',
  RESCHEDULE_APPROVED: 'reschedule_approved',
  RESCHEDULE_COMPLETED: 'reschedule_completed',
  STARTED: 'started',
  REFEREE_CHANGED: 'referee_changed',
  COMPLETED: 'completed'
};

/**
 * Log a match update event
 * @param {string} matchId
 * @param {string} type - LOG_TYPES value
 * @param {object} details - type-specific details (e.g. { oldDate, newDate, performedByName })
 * @param {string} performedBy - user id
 * @param {string} performedByName - display name
 */
export async function logMatchUpdate(matchId, type, details = {}, performedBy, performedByName) {
  try {
    await addDoc(collection(db, 'matchUpdateLogs'), {
      matchId,
      type,
      ...details,
      performedBy: performedBy || null,
      performedByName: performedByName || '',
      performedAt: Timestamp.now()
    });
  } catch (err) {
    console.error('[matchUpdateLogService] Failed to log:', err);
  }
}

/**
 * Fetch update logs for a match, newest first
 */
export async function getMatchUpdateLogs(matchId) {
  try {
    const q = query(
      collection(db, 'matchUpdateLogs'),
      where('matchId', '==', matchId),
      orderBy('performedAt', 'desc')
    );
    const snapshot = await getDocs(q);
    return snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
  } catch (err) {
    console.error('[matchUpdateLogService] Failed to fetch logs:', err);
    return [];
  }
}
